import { getMatchedJobsThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import CodingExamCard from '../../../../../components/CodingExamCard';
import { setJobBoxTab } from '../../../../../store/workspace/slice';
import { selectUserId } from '../../../../../store/auth/selectors';
import { JobBoxTab } from '../../../../../store/workspace/types';
import InterviewCard from '../../../../../components/InteviewCard';
import { InfoIcon } from '../../../../../assets/icons/common';
import DropDown from '../../../../../components/DropDown';
import Spinner from '../../../../../components/Spinner';
import JobCard from '../../../../../components/JobCard';
import Button from '../../../../../components/Button';
import { DashboardStage, StageJobs } from '../../types';
import { useJobStages } from '../../hooks/useJobStages';
import { dashboardStages } from '../../constants';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import { useEffect } from 'react';
import {
    selectJobBoxTab,
    selectLoadingMatchedJobs,
} from '../../../../../store/workspace/selectors';

/** Every stage lists its own kind of card. */
const stageCards = (stage: JobBoxTab, jobs: StageJobs) => {
    switch (stage) {
        case 'RecruitingInterview':
            return jobs.RecruitingInterview.map(job => <JobCard
                key={job.id}
                jobDetail={job}
                tab='recruitingInterview'
                CtaTitle='Start recruiting interview'
            />);
        case 'MultipleChoice':
            return jobs.MultipleChoice.map(job => <JobCard key={job.id} tab='multipleChoiceExam' jobDetail={job} />);
        case 'Coding':
            return jobs.Coding.map(job => <CodingExamCard key={job.id} jobDetail={job} />);
        case 'Interview':
            return jobs.Interview.map(job => <InterviewCard key={job.id} jobDetail={job} />);
        case 'FinalResult':
            return jobs.FinalResult.map(job => <InterviewCard key={job.id} jobDetail={job} showStatus />);
    }
};

interface Props {
    /** The applicant is not looking for a job, so there is nothing to match them with. */
    matchingDisabled: boolean;
};

/** The jobs the applicant was matched with, one tab per stage of the funnel. */
function JobBox(props: Props) {
    const { matchingDisabled } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const jobs = useJobStages();
    const tab = useSelector(selectJobBoxTab);
    const userId = useSelector(selectUserId);
    const loading = useSelector(selectLoadingMatchedJobs);
    const activeStage = dashboardStages.find(stage => stage.id === tab);

    useEffect(() => {
        if (!userId) return;
        dispatch(getMatchedJobsThunk(userId));
    }, [userId]);

    const renderJobList = () => {
        if (matchingDisabled) return <>
            <div className={styles.jobList_setting}>
                <InfoIcon />
                <span>First, change your status to actively looking for a new job in settings.</span>
            </div>
            <Button
                text='Navigate To Settings'
                className={styles.jobList_setting_cta}
                onClick={() => navigate('/workspace/settings')}
            />
        </>;

        if (loading) return <Spinner />;

        if (jobs[tab].length === 0) return (
            <span className={styles.jobList_empty_state}>{activeStage?.emptyState}</span>
        );

        return stageCards(tab, jobs);
    };

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>
                Potential jobs based on your profile
            </span>

            <div className={styles.tab}>
                {dashboardStages.map(({ id, title }) => <div
                    key={id}
                    className={styles.tab_item}
                    data-is-active={tab === id}
                    onClick={() => dispatch(setJobBoxTab(id))}
                >
                    <span>{title}</span>
                </div>)}
            </div>

            <DropDown
                idKey='id'
                titleKey='title'
                selectedItem={activeStage}
                dropDownList={dashboardStages}
                containerClassName={styles.tab_dropdown}
                setItem={(stage: DashboardStage) => dispatch(setJobBoxTab(stage.id))}
            />

            <div className={styles.jobList}>{renderJobList()}</div>
        </div>
    )
};

export default JobBox;
